import { render, staticRenderFns } from "./PleurisyTooltip.vue?vue&type=template&id=1a5e84ec&scoped=true&"
import script from "./PleurisyTooltip.vue?vue&type=script&lang=ts&"
export * from "./PleurisyTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./PleurisyTooltip.vue?vue&type=style&index=0&id=1a5e84ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5e84ec",
  null
  
)

export default component.exports